import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './dataAccess/store'
import vuetify from './plugins/vuetify'
import './plugins/vuelidate'
import './filters/VueTruncate'
import './utils/array'
import capitalize from './filters/capitalize'
import DataTimeFilter from './filters/datetime'
import DataFilter from './filters/date'
import TimeFilter from './filters/time'
import Employee from '@/dataAccess/models/Employee'
import AccessibleClient from '@/dataAccess/models/AccessibleClient'

Vue.prototype.$eventBus = new Vue()
Vue.prototype.Employee = Employee
Vue.prototype.AccessibleClient = AccessibleClient

Vue.filter('time', TimeFilter)
Vue.filter('date', DataFilter)
Vue.filter('datetime', DataTimeFilter)
Vue.filter('capitalize', capitalize)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
